module.exports = __webpack_public_path__ + "static/img/13.684ad0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/13.jpg
// module id = UghN
// module chunks = 21